export const importedretailersmetrics = {
   'retailersCount': 60,
   'marketsCount': 4
 };